import React, { useEffect, useState } from 'react';
import styles from "./meetingscreen.module.scss";
import { useSelector } from 'react-redux';
import { initialStateModel } from '../../base/models/meetModal';
import _ from 'lodash';
import VideoMeetingCustomer from './videomeetingcustomer';

type JoinMeetingScreenState = {
  shareSelect: boolean;
  isSettingSide: boolean;
  isParticipantSide: boolean;
  isVirtualBG: boolean;
  isChat: boolean;
  isWhiteBoardDevice: string;
  toggleSettings: boolean;
  isAutomatedmins: boolean;
  isTranscript: boolean;
  draggableScreen: boolean;
  leaveAssign: any;
}


const JoinMeetingScreenComponent = () => {
  const videoMeetState: initialStateModel = useSelector((state: initialStateModel) => state);
  const { currdeviceinfo,  iceState } = videoMeetState.meetingReducer;
  let part: any = currdeviceinfo?.isHost ? true : false;

  const [joinMeetingState, setJoinMeeting] = useState<JoinMeetingScreenState>({
    shareSelect: false, isSettingSide: false, isParticipantSide: part
    , isChat: false, isVirtualBG: false, isWhiteBoardDevice: '', toggleSettings: false,
    isAutomatedmins: false, isTranscript: false, draggableScreen: false, leaveAssign: []
  });


  useEffect(() => {
    if (iceState && currdeviceinfo.isHost) {
      setJoinMeeting({ ...joinMeetingState, isParticipantSide: false });
    }
  }, [iceState])



  return (<>

    <div className={styles.meetingscreens}>
      <div className={styles.mainsections} >
        
          <VideoMeetingCustomer /> 
      </div >

    </div >

  </>
  );

};

export const JoinMeetingScreen = React.memo(JoinMeetingScreenComponent);
